/**
 * Admin Diagnostics & Archive Tab Component
 * 
 * Centralized view for diagnostics, archived signals, and DLQ monitoring.
 * Combines existing AdminExitSignalsTab and AdminDLQTab functionality.
 */

import { AdminExitSignalsTab } from "@app/features/admin-exit-signals/AdminExitSignalsTab";
import { AdminDLQTab } from "@app/features/admin-dlq/AdminDLQTab";
import "./admin-diagnostics.css";

export function AdminDiagnosticsTab(): JSX.Element {
  return (
    <div className="admin-diagnostics-root">
      <div className="admin-diagnostics-section">
        <h2>Archived Exit Signals</h2>
        <AdminExitSignalsTab />
      </div>
      <div className="admin-diagnostics-section">
        <h2>Dead Letter Queue</h2>
        <AdminDLQTab />
      </div>
    </div>
  );
}

